
<div class="app-update"><img id="logo" src="../../assets/images/logo_new.svg"/><img id="robot" src="https://mycolor.space/img/color-scheme-right.svg"/>
  <div class="update-text">
    <div><img id="setting" src="/assets/images/setting.svg"/><span>Hey {{user?.get('username')}}, Time to update your app.</span></div>
    <div class="fontS mt-3">We got a message from the galaxy that you are using the older version of app. Kindly update it to enjoy the latest features & fixes.</div>
    <button class="btn" (click)="reloadApp()">UPDATE</button>
  </div>
</div>